import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

const translationStore = new Vuex.Store({
  state: {
    traduzioni: {},
    avaiable: {},
    linguaCorrente: 'en_GB',
    traduzioniCaricate: false // Flag per indicare se le traduzioni sono caricate
  },
  mutations: {
    setAvaiable (state, avaiable) {
      state.avaiable = avaiable
    },
    setTraduzioni (state, traduzioni) {
      state.traduzioni = traduzioni
    },
    setLinguaCorrente (state, lingua) {
      state.linguaCorrente = lingua
    },
    setTraduzioniCaricate (state) {
      state.traduzioniCaricate = true
    }
  },
  actions: {
    caricaTraduzioni ({ commit }, json) {
      const t = {}
      const a = {}

      const trans = json.translations
      const av = json.availableLanguages

      if (av && Array.isArray(av)) {
        av.forEach(item => {
          if (!a[item.code]) {
            a[item.code] = {
              language: item.code,
              flag: item.flag
            }
          }
        })
      }

      if (trans && Array.isArray(trans)) {
        trans.forEach(item => {
          if (!t[item.code]) {
            t[item.code] = {}
          }
          t[item.code][item.key] = item.translation

          // Aggiungiamo le informazioni sulla lingua solo se non esistono già
          // if (!a[item.code]) {
          //   a[item.code] = {
          //     language: item.language,
          //     flag: item.flag
          //   }
          // }
        })
      }

      commit('setAvaiable', a)
      commit('setTraduzioni', t)
      commit('setTraduzioniCaricate')
    },
    cambiaLingua ({ commit }, lingua) {
      commit('setLinguaCorrente', lingua)
    }
  },
  getters: {
    traduzione: (state) => (chiave) => {
      const traduzione = state.traduzioni[state.linguaCorrente] && state.traduzioni[state.linguaCorrente][chiave]
      if (traduzione) {
        return traduzione
      }
      // Lingua di fallback (inglese)
      return state.traduzioni.en && state.traduzioni.en[chiave]
    },
    traduzioniCaricate: (state) => state.traduzioniCaricate, // Getter per il flag
    linguaCorrente: (state) => state.linguaCorrente, // Getter per la lingua corrente
    avaiable: (state) => state.avaiable,
    linguapresente: (state) => state.traduzioni
  },
  plugins: [
    createPersistedState({
      key: 'transaltionStore',
      // Scegli dove persistere lo stato
      storage: window.localStorage, // Questo è il default, ma è buona pratica specificarlo
      // Quali proprietà di primo livello dello stato vuoi persistere
      paths: [
        'traduzioni', // Persisti l'oggetto userinfo
        'avaiable',
        'linguaCorrente',
        'traduzioniCaricate'
      ]

    })
  ]
})

export default translationStore
